/** C20 → C12: « Lancer une campagne avec cette offre » (opens the campaign form with the offer chosen). */

import { Megaphone } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function LaunchCampaignLink({ offerId }: { offerId: string }) {
  const { t } = useTranslation();
  return (
    <Link className="link" to={`/ads?offer=${encodeURIComponent(offerId)}`}>
      <Megaphone size={16} aria-hidden="true" /> {t("ads.fromOffer")}
    </Link>
  );
}
